// libs
import { useSelector } from 'react-redux'
// store
import { objectEntitiesSelector } from 'store/reducers/objectEntities'

// review picklist field ids for the given object entity (by name), used to hide them from the main entity form
export const useReviewFieldIds = (entityName: string): string[] => {
  const objectEntities = useSelector(objectEntitiesSelector)

  return objectEntities.find((item) => item.name === entityName)?.reviewFieldIds || []
}
